export const childEmailBookingFormFieldName = 'childEmailAddress'
export const childPhoneBookingFormFieldName = 'childPhone'
export const childSMSConsentBookingFormFieldName = 'childSMSConsent'
